App.directive('toogleFields', function() { 
    return {
        restrict: 'A',
        scope: {
            target: '@'
        },
        link: function(scope, elm) {
            $(elm[0]).on('click', function() {
                var target = $(scope.target);
                var h = target[0].scrollHeight;

                var head = $('.variant .all .head').eq(0);
                var table = $('.variant .all .table').eq(0);
                var rows = table.children().splice(0, 4);

                var hStart = head[0].scrollHeight + rows[0].scrollHeight + rows[1].scrollHeight + rows[2].scrollHeight + 16;

                if (!$(target).hasClass('open')) {
                    $('.fixed_block').hide();
                    $(rows[3]).find('.cell').css({'border-top-width': '0px', 'border-left-width': '0px'});
                    $(elm[0]).text('Rozwiń zakres');
                    $(target).addClass('open');
                    $(target).velocity("stop", true).velocity({height: hStart});
                } else {
                    $('.fixed_block').show();
                    $(rows[3]).find('.cell').css({'border-top-width': '1px', 'border-left-width': '1px'});
                    $(elm[0]).text('Zwiń zakres');
                    $(target).removeClass('open');
                    $(target).velocity("stop", true).velocity({height: h});
                }
            });
        }
    }
});